export const THREE_COLUMNS = 'THREE_COLUMNS'
export const TWO_COLUMNS = 'TWO_COLUMNS'
